import { useState } from 'react'
import { toast } from 'sonner'
import { EcommercePlatformField } from '@/components/shared/EcommercePlatformField'
import api from '@/services/api'
import type { Deal } from '@/types'
import { cn } from '@/utils/cn'
import { normalizeEcommercePlatform } from '@/constants/ecommercePlatforms'
import { validateEcommercePlatformField } from '@/utils/leadRegistrationValidation'
import { getFriendlyError } from '@/utils/getFriendlyError'

export function DealProposalPlatformField({
  deal,
  onSaved,
}: {
  deal: Deal
  onSaved: (plataforma: string) => void
}) {
  const [value, setValue] = useState(deal.plataforma?.trim() ?? '')
  const [saving, setSaving] = useState(false)
  const empty = !value.trim()

  const save = async (next: string) => {
    const plataforma = normalizeEcommercePlatform(next) || next.trim()
    if (!plataforma || plataforma === (deal.plataforma?.trim() ?? '')) {
      setValue(plataforma)
      return
    }
    const invalid = validateEcommercePlatformField(plataforma)
    if (invalid.plataforma) {
      toast.error(invalid.plataforma)
      return
    }
    setSaving(true)
    try {
      if (deal.empresaId) {
        await api.patch(`/empresas/${deal.empresaId}`, { plataforma })
      }
      if (deal.instanceId) {
        await api.patch(`/closer-leads/${deal.instanceId}`, { plataforma })
      }
      setValue(plataforma)
      onSaved(plataforma)
    } catch (error: unknown) {
      toast.error(getFriendlyError(error, 'Não foi possível salvar a plataforma no cadastro'))
    } finally {
      setSaving(false)
    }
  }

  return (
    <div
      className={cn(
        'col-span-2',
        empty && 'field-attention-shell rounded-xl border-2 border-warning p-3',
      )}
    >
      <EcommercePlatformField
        value={value}
        onChange={(next) => {
          setValue(next)
          void save(next)
        }}
        error={empty ? 'Obrigatória para marcar a proposta como enviada' : undefined}
        hint={saving ? 'Salvando no cadastro…' : 'Fica no cadastro da empresa.'}
      />
    </div>
  )
}
